export default {
  'order.QueryFailedPleaseTryAgain': 'Query failed, please try again',
  'order.paymentSuccessful': 'payment successful',
  'order.ThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation':
    'The payment is successful, please return to WeChat to continue the operation',
  'order.FailedToGetOrderInformation': 'Failed to get order information',
  'order.AlipayScanCodePayment': 'Alipay scan code payment',
  'order.ScanCodePayment': 'Scan code payment',
  'order.Cancel': 'Cancel'
};
